import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Services() {
  const fullDetailPackages = [
    {
      type: 'Small Cars',
      cleanPrice: '$110',
      dirtyPrice: 'Custom quote',
      description: 'Complete interior and exterior detailing for compact vehicles'
    },
    {
      type: 'Medium Cars',
      cleanPrice: '$137',
      dirtyPrice: 'Custom quote',
      description: 'Full service detailing for mid-size sedans and SUVs'
    },
    {
      type: 'Trucks / Large Vehicles',
      cleanPrice: '$155',
      dirtyPrice: 'Custom quote',
      description: 'Comprehensive detailing for trucks and large vehicles'
    }
  ];

  const interiorPackages = [
    {
      type: 'Small Cars',
      cleanPrice: '$65',
      dirtyPrice: 'Custom quote',
      description: 'Deep interior cleaning and protection'
    },
    {
      type: 'Medium Cars',
      cleanPrice: '$75',
      dirtyPrice: 'Custom quote',
      description: 'Thorough interior detailing service'
    },
    {
      type: 'Trucks',
      cleanPrice: '$85',
      dirtyPrice: 'Custom quote',
      description: 'Complete interior cleaning for large vehicles'
    }
  ];

  const exteriorPackages = [
    {
      type: 'Small Cars',
      price: '$60',
      description: 'Exterior wash, dry, and basic protection'
    },
    {
      type: 'Medium Cars',
      price: '$68',
      description: 'Complete exterior cleaning and shine'
    },
    {
      type: 'Trucks',
      price: '$78',
      description: 'Full exterior detailing for large vehicles'
    }
  ];

  const addOns = [
    {
      name: 'Wax Sealant',
      price: '$40',
      description: 'Premium protection with long-lasting shine and weather resistance',
      icon: 'ri-shield-star-line'
    },
    {
      name: 'Tire Shine',
      price: '$10',
      description: 'Professional tire treatment for enhanced appearance',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat py-24"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/e88ada64db3193888b9a84ae586990c8/20ab59a77ed2eb6c52c9f7561aa78b81.jpeg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Services</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Professional mobile detailing packages designed to keep your vehicle looking its best
          </p>
        </div>
      </section>

      {/* Full Detail Packages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Full Detail Packages
            </h2>
            <p className="text-lg text-black mb-4">Interior + Exterior</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {fullDetailPackages.map((pkg, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-black mb-2">{pkg.type}</h3>
                  <p className="text-black">{pkg.description}</p>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-4 bg-red-50 rounded-lg">
                    <span className="font-medium text-black">Clean condition:</span>
                    <span className="text-2xl font-bold text-red-600">{pkg.cleanPrice}</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-black/5 rounded-lg">
                    <span className="font-medium text-black">Dirty condition:</span>
                    <span className="text-lg font-semibold text-black">{pkg.dirtyPrice}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Interior Only Packages */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Interior-Only Packages
            </h2>
            <p className="text-lg text-black">Deep cleaning and protection for your vehicle's interior</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {interiorPackages.map((pkg, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
                <div className="text-center mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-lg mx-auto mb-4">
                    <i className="ri-steering-2-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-2">{pkg.type}</h3>
                  <p className="text-black">{pkg.description}</p>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-4 bg-red-50 rounded-lg">
                    <span className="font-medium text-black">Clean:</span>
                    <span className="text-2xl font-bold text-red-600">{pkg.cleanPrice}</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-black/5 rounded-lg">
                    <span className="font-medium text-black">Dirty:</span>
                    <span className="text-lg font-semibold text-black">{pkg.dirtyPrice}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Exterior Only Packages */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Exterior-Only Packages
            </h2>
            <p className="text-lg text-black">Professional wash, wax, and exterior protection</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {exteriorPackages.map((pkg, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow">
                <div className="text-center mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-lg mx-auto mb-4">
                    <i className="ri-drop-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-2">{pkg.type}</h3>
                  <p className="text-black">{pkg.description}</p>
                </div>
                <div className="text-center">
                  <div className="p-4 bg-red-50 rounded-lg">
                    <span className="text-3xl font-bold text-red-600">{pkg.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Add-ons */}
      <section className="py-20 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Premium Add-Ons</h2>
            <p className="text-lg text-gray-300">Enhance your detailing service with these premium upgrades</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {addOns.map((addon, index) => (
              <div key={index} className="bg-gray-900 rounded-xl p-8 text-center hover:bg-gray-800 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full mx-auto mb-6">
                  <i className={`${addon.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-2">{addon.name}</h3>
                <p className="text-3xl font-bold text-red-600 mb-4">{addon.price}</p>
                <p className="text-gray-300">{addon.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Book Your Service?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            To book, text 980-261-1286 and we'll give you a quote
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="sms:+19802611286"
              className="inline-block bg-white text-red-600 hover:bg-black hover:text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap px-8 py-3 text-lg"
            >
              Text Us Now
            </a>
            <Link to="/maintenance">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-red-600">
                Learn About Maintenance Plans
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
